import app from 'app';
import Marionette from 'backbone.marionette';

export default Marionette.ItemView.extend({
  className: 'js-connection-status-view wt-notification-view',

  ui: {
    $btnClose: '.js-hide',
    $btnReload: '.js-reload',
    $btnLogin: '.js-login',
    $countdown: '.js-countdown',
  },

  events: {
    'click @ui.$btnClose': 'destroy',
    'click @ui.$btnReload': '_reload',
    'click @ui.$btnLogin': '_login',
  },

  _countDownTimer: null,
  _closeTimer: null,

  onBeforeDestroy: function () {
    if (this._closeTimer) {
      window.clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
    this._stopCountDownTimer();
  },

  modelEvents: {
    'change:timeout': '_timeout_changed',
  },

  initialize: function () {
    this.viewState = new Backbone.Model({
      countdown: 0,
    });
    this.listenTo(this.viewState, 'change:countdown', this._reflectCountdown);

    this.template = app.compileTemplate.$('#connection-status-tmpl');

    if (app.CONNECTION.ESTABLISHED === this.model.get('mode')) {
      this._closeTimer = window.setTimeout(
        function () {
          this.destroy();
        }.bind(this),
        app.TIME.second(1.6)
      );
    }
  },

  _timeout_changed: function (model, timeout) {
    if (_.isDefined(timeout) && timeout > 0) {
      this._startCountdownFrom(timeout);
    }
  },
  _startCountdownFrom: function (seconds) {
    this.viewState.set('countdown', seconds);

    this._stopCountDownTimer();
    this._countDownTimer = window.setInterval(
      function () {
        if (this.viewState.get('countdown') > 0) {
          this.viewState.set('countdown', this.viewState.get('countdown') - 1);
        } else {
          this._stopCountDownTimer();
        }
      }.bind(this),
      app.TIME.SECOND
    );
  },
  _stopCountDownTimer: function () {
    if (this._countDownTimer) {
      window.clearTimeout(this._countDownTimer);
      this._countDownTimer = null;
    }
  },
  _reflectCountdown: function (viewState, countdown) {
    if (countdown > 0) {
      this.ui.$countdown.text(['in ', countdown, 's.'].join(''));
    } else {
      this.ui.$countdown.text('...');
    }
  },

  serializeData: function () {
    return {
      mode: this.model.get('mode'),
      _modeText: app.culture.notificationMessages[this.model.get('mode')],
    };
  },

  _reload: function (e) {
    e.preventDefault();
    app.stop();
    window.location.reload();
  },

  _login: function (e) {
    e.preventDefault();
    app.state.enableNavigation();
    app.navigate2Login({ allowGetBack: true });
  },
});
